import React, { Component } from 'react';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import Header from '../components/Header/header';
import Privacy from '../components/Privacy';
import FooterSection from '../components/Footer';

class PrivacyPage extends Component {
  render() {
    return (
      <>
        <MessengerCustomerChat
          pageId="101590111335192"
          appId="695593052231950" 
        />
        <Header />
        <div className="main">
          <Privacy />
        </div>
        <FooterSection />
      </>
    );
  }
}

export default PrivacyPage;
